module.exports = __webpack_public_path__ + "img/dang1.c2128570.png";